module.exports = __webpack_public_path__ + "img/f71.27c99fe9.png";